import { StylizedCardItemLinkWithIcon } from 'src/app/components/Elements/Card/StylizedCardItemLinkWithIcon';
import * as paths from 'src/app/router/paths';
import type { CheckoutPickupSectionProps } from 'src/app/types';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

export const CheckoutPickupSection = ({
  bffCartDeliveryAddress,
  cartId,
  dispatchAddressListClicked,
  dispatchDeliveryWindowsListClicked,
  deliveryMethodFirstRowText,
  deliveryMethodSecondRowText,
  hasChosenPickupStationAfterSettingDeliveryMethodAsCourier,
  hasAlreadyChosenCourierDeliveryAddress,
  hasError,
}: CheckoutPickupSectionProps) => {
  const { name, address, addressTwo, city, state, zipCode } = bffCartDeliveryAddress || {};
  const hasChosenPickupStation =
    !!bffCartDeliveryAddress &&
    !hasChosenPickupStationAfterSettingDeliveryMethodAsCourier &&
    !hasAlreadyChosenCourierDeliveryAddress;

  const addressErrorText = `• Missing Pickup Location`;
  const deliveryMethodErrorText = `• Missing Pickup Time`;
  return (
    <>
      <StylizedCardItemLinkWithIcon
        sectionTitle={hasError && !bffCartDeliveryAddress ? addressErrorText : 'Pickup Location'}
        capsuleIcon={CAPSULE_ICON_STRINGS.checkout_address}
        to={paths.checkoutSelectPickupStation.toPath({ cartId })}
        ariaLabel={'Choose Pickup Location'}
        handleOnClick={dispatchAddressListClicked}
        dataCy={'checkout-pickup'}
        textList={
          hasChosenPickupStation
            ? [name, address, addressTwo, `${city}, ${state} ${zipCode}`]
            : ['Choose a pickup location']
        }
        isDisabled={false}
        disabledText={'Choose a pickup location'}
        shouldBoldFirstText={hasChosenPickupStation}
        hasError={hasError}
      />
      <StylizedCardItemLinkWithIcon
        sectionTitle={
          hasError && (!deliveryMethodFirstRowText || deliveryMethodFirstRowText === 'Choose delivery time')
            ? deliveryMethodErrorText
            : 'Pickup Time'
        }
        capsuleIcon={CAPSULE_ICON_STRINGS.checkout_delivery}
        to={!!deliveryMethodFirstRowText}
        ariaLabel={'Pickup Time'}
        handleOnClick={dispatchDeliveryWindowsListClicked}
        dataCy={'checkout-pickup-time'}
        textList={
          !!deliveryMethodFirstRowText
            ? [deliveryMethodFirstRowText, deliveryMethodSecondRowText]
            : ['Choose a pickup location to see your pickup time']
        }
        isDisabled={!!!deliveryMethodFirstRowText || deliveryMethodFirstRowText === 'Choose delivery time'}
        disabledText={'Choose a pickup location to see your pickup time'}
        showArrow={false}
        noMaxWidth
        hasError={hasError}
      />
    </>
  );
};
